import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import TuneIcon from "@mui/icons-material/Tune";

import AdvancedSearch from "src/components/AdvancedSearch/index";

export default function TableSearch({
  placeholder,
  onChange,
  value: initialValue,
  disabled,
  fields,
}) {
  const [value, setValue] = useState(initialValue);
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);

  const handleInputKeyup = event => {
    event.persist();

    if (event.keyCode === 13 && event.target.value) {
      setValue(event.target.value);
    }
  };

  const handleInputChange = event => {
    event.persist();
    setValue(event.target.value);
  };

  const handleSubmit = event => {
    event.preventDefault();
    onChange(value);
  };

  const handleAdvancedSearchSubmit = value => {
    setValue(value);
    onChange(value);
    setShowAdvancedSearch(false);
  };

  const handleClear = () => {
    setValue("");
    onChange("");
  };

  return (
    <Box sx={{ position: "relative" }}>
      <Paper>
        <form onSubmit={handleSubmit}>
          <TextField
            sx={{
              minWidth: { sx: 200, sm: 400 },
              "& .MuiOutlinedInput-input": {
                padding: "8px 12px",
              },
            }}
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {value && (
                    <IconButton onClick={handleClear}>
                      <CloseIcon />
                    </IconButton>
                  )}
                  <Box sx={{ width: "1px", height: 24, bgcolor: "divider", mx: 0.5 }} />
                  <Tooltip arrow title="Advanced Search">
                    <IconButton onClick={() => setShowAdvancedSearch(true)}>
                      <TuneIcon />
                    </IconButton>
                  </Tooltip>
                  <IconButton type="submit">
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            fullWidth
            onChange={handleInputChange}
            onKeyUp={handleInputKeyup}
            placeholder={placeholder || "Enter a keyword"}
            value={value || ""}
            disabled={disabled}
          />
        </form>
        <Box position="relative">
          {showAdvancedSearch && (
            <AdvancedSearch
              initialValue={value}
              onSearch={handleAdvancedSearchSubmit}
              onCancel={() => setShowAdvancedSearch(false)}
              fields={fields}
            />
          )}
        </Box>
      </Paper>
    </Box>
  );
}
